import { extension } from "_constants";
import { PrimeIcons } from "primereact/api";

import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { ProgressBar } from "primereact/progressbar";
import { formatBytes, getFileIconByFileType } from "utils";

export const ItemTemplate = ({
  file,
  deleteFile,
  loading,
  handleCancelUpload,
  uploadPercentage,
}: any) => {
  return (
    <div className="upload-source-content">
      <div className="file-upload flex-container justify-between">
        <div className="flex-container align-center inner">
          <img
            src={getFileIconByFileType(file.fileType ?? file.type)}
            alt={extension}
          />
          <Tooltip target={`.file-name`} mouseTrack mouseTrackLeft={10} />
          <span
            className="file-upload-name ellipsis file-name flex-1"
            data-pr-tooltip={file.name}
          >
            {file.name}
          </span>
          <span className="file-upload-size">{`•  ${formatBytes(file.size, 2)}
          `}</span>
        </div>
        {loading ? (
          <div className="progress-container">
            <ProgressBar
              className="width-100 height-100"
              showValue={false}
              value={uploadPercentage}
            ></ProgressBar>
            <Button
              icon={PrimeIcons.TIMES}
              text
              severity="danger"
              onClick={handleCancelUpload}
            />
          </div>
        ) : (
          <Button
            icon={PrimeIcons.TRASH}
            onClick={deleteFile}
            text
            severity="danger"
          />
        )}
      </div>
    </div>
  );
};
